import api from './api';
import { getFounderUrl, getProdPublishUrl, getWorksheetUrl } from './https';

const getPublishUrl = (url: string) => {
  const protocol = window.location.protocol;
  const isInstra = location.origin.indexOf('hexin.im') > 0 || location.origin.indexOf('localhost') > 0 || location.origin.indexOf('192.') > 0;
  const suffix = isInstra ? 'publish.hexin.im' : 'publish.hexinedu.com';
  return `${protocol}//${suffix}${url}`;
};

export const getOrder = (params: { customer_id: string }) => {
  return api.get('/api/worksheet/admin/ticket/v1/search/client', params);
};

export const getDeliver = (params: { ticket_id: string }) => {
  return api.get('/api/worksheet/admin/content/v1/deliverable', params);
};

export const getVerifyDeliver = (params: { ticket_id: string; process_name?: string }) => {
  return api.get('/api/worksheet/admin/content/v1/deliverable/verification', params);
};
// @tips: 需要从该api获取压缩包中文件的文件夹路径
export const getSeewoZipList = (params: { project_id: string;}) => {
  return api.get(getPublishUrl('/api/seewo_zip/task/list'), params);
};

/**
 * 获取点数
 */
export const getDeductPoint = (data: { ticket_id: string; point_type: string }) => {
  return api.post(getWorksheetUrl('/admin/ticket/v1/deduct_point'), data);
};

export const rerunStu2TeaOrder = (params: { ticket_id: string; run_type: string }) => {
  return api.post(getPublishUrl('/api/fbd_align/task/open/generate'), params, { withCredentials: false });
};

export const rerunWord2FbdOrder = (params: { ticket_id: string; run_type: string }) => {
  return api.post(getPublishUrl('/api/word_fbd/task/open/generate'), params, { withCredentials: false });
};

export const rerunOrderStatus = (params: { ticket_id: string; status?: number }) => {
  return api.post('/api/worksheet/admin/ticket/v1/rerun', params, { withCredentials: false });
};

export const reRunWord2PPTTask = (data: any) => {
  return api.post(getProdPublishUrl('/word_ppt/project/rerun'), data);
};

export const reRunJSON2PPTTask = (data: any) => {
  return api.post(getProdPublishUrl('/json_ppt/project/batch/rerun'), data);
};

export const getStyleList = (params: { type: any; size: any; limit: number; skip: number; customer_id: number; search?: any }) => {
  return api.get(getPublishUrl('/api/pool/style/open/list'), params, { withCredentials: false });
};

export const getStyleInfo = (params: {}) => {
  return api.get(getPublishUrl('/api/pool/style/info'), params, { withCredentials: false });
};

export const getStyleConfig = (params: {}) => {
  return api.get(getPublishUrl('/api/pool/style/open/get'), params, { withCredentials: false });
};

export const creatStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/pool/style/open/create'), params, { withCredentials: false });
};

export const copyStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/pool/style/copy'), params, { withCredentials: false });
};
export const copyFBDStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/fbd_align/style/copy'), params, { withCredentials: false });
};

export const editStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/pool/style/open/edit'), params, { withCredentials: false });
};

export const getFbdStyleList = (params: { limit: number; skip: number; customer_id: number; search?: any }) => {
  return api.get(getPublishUrl('/api/fbd_align/style/list'), params, { withCredentials: false });
};

export const getFbdStyleConfig = (params: {}) => {
  return api.get(getPublishUrl('/api/fbd_align/style/info'), params, { withCredentials: false });
};

export const creatFbdStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/fbd_align/style/create'), params, { withCredentials: false });
};

export const editFbdStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/fbd_align/style/edit'), params, { withCredentials: false });
};

// 删除学转教模板库
export const deleteFbdStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/fbd_align/style/delete'), params, { withCredentials: false });
};
// 删除方正模板库
export const deleteStudyStyle = (params: {}) => {
  return api.post(getPublishUrl('/api/pool/style/open/delete'), params, { withCredentials: false });
};


export const getDraftingImageList = (params: {}) => {
  return api.get(getPublishUrl('/api/image_gallery/image/get_all'), params, { withCredentials: false });
};

export const getDraftingProjectInfo = (params: {}) => {
  return api.get(getPublishUrl('/api/image_gallery/image/project/info'), params, { withCredentials: false });
};

export const creatGalleryProject = (params: {}) => {
  return api.post(getPublishUrl('/api/image_gallery/image/gallery/generate'), params, { withCredentials: false });
};

export const editDraftingProject = (params: {}) => {
  return api.post(getPublishUrl('/api/image_gallery/image/project/edit'), params, { withCredentials: false });
};

export const uploadStyle = (params: {}) => {
  return api.post(getFounderUrl('/sigma_xml2fbd/style/generate_temp_style'), params);
};

// 获取当前客户下单的服务类型
export const getServiceType = () => {
  return api.get(getWorksheetUrl('/admin/ticket/v1/service_content/get'));
};

// 获取扣除点数比例
export const getDeductRatio = (params: {}) => {
  return api.get(getWorksheetUrl('/admin/ticket/v1/deduct_ratio'), params);
};

// 获取扣点数量
export const getDeductCount = (params: {}) => {
  return api.get(getWorksheetUrl('/admin/ticket/v1/deduct_point'), params);
};

export const getTemplateInfoOneByOneInVBA = (params: { simple_id: string }) => {
  const protocol = window.location.protocol;
  return api.get(`${protocol}//sigma-ppt.hexinedu.com/api/admin/simple/script/manual`, params);
};

// 获取word2ppt模板列表
export const getTemplatesByOrg = (params: { search: string, customer_id: string | number }) => {
  const protocol = window.location.protocol;
  return api.get(`${protocol}//sigma-ppt.hexinedu.com/api/admin/simple/list`, params);
};

export const getTemplatesStyle = (params: { simple_id: string }) => {
  const protocol = window.location.protocol;
  return api.get(`${protocol}//sigma-ppt.hexinedu.com/api/admin/simple/config/edit`, params);
};

export const getTemplatesStyleMaterials = (params: { simple_id: string }) => {
  const protocol = window.location.protocol;
  return api.get(`${protocol}//sigma-ppt.hexinedu.com/api/admin/simple/material/list`, params);
};